import styled, { css } from 'styled-components';

import Button from '@prisjakt/ui-button';
import { layout } from '@prisjakt/ui-base';

import {
  EmoticonAngry,
  EmoticonDissatisfied,
  EmoticonNeutral,
  EmoticonSmiling,
  EmoticonLaughing,
} from '../icons';

export const UserSentimentForm = styled.div`
  text-align: center;
  padding: ${layout.spacing.small};
`;

export const Title = styled.div`
  font-size: 12px;
  color: ${p => p.theme.text.quaternary};
  text-align: center;
`;

export const Question = styled.div`
  font-weight: 600;
  font-size: 14px;
  text-align: center;
  margin-bottom: ${layout.spacing.small};
`;

export const Rating = styled.div`
  margin-top: ${layout.spacing.small};
`;

export const RateButton = styled.button`
  cursor: pointer;

  &:not(:last-of-type) {
    margin-right: ${layout.spacing.small};
  }
`;

export const SubmitButton = styled(Button)`
  width: 100%;
  margin-top: ${layout.spacing.small};
`;

const shared = css`
  fill: transparent;
  transition: fill 200ms ease;
`;

export const Angry = styled(EmoticonAngry)`
  > g {
    ${shared};
    stroke: ${p => p.theme.icons.primary};

    &:hover {
      fill: #ff5a50;
    }
  }
`;

export const Dissatisfied = styled(EmoticonDissatisfied)`
  > g {
    ${shared};
    stroke: ${p => p.theme.icons.primary};

    &:hover {
      fill: #fd9002;
    }
  }
`;

export const Neutral = styled(EmoticonNeutral)`
  > g {
    ${shared};
    stroke: ${p => p.theme.icons.primary};

    &:hover {
      fill: #ffd403;
    }
  }
`;

export const Smiling = styled(EmoticonSmiling)`
  > g {
    ${shared};
    stroke: ${p => p.theme.icons.primary};

    &:hover {
      fill: #65d1ff;
    }
  }
`;

export const Laughing = styled(EmoticonLaughing)`
  > g {
    ${shared};
    stroke: ${p => p.theme.icons.primary};

    &:hover {
      fill: #74cf61;
    }
  }
`;
